import React from "react";
import styled, { css } from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";
import { ActionConfig, ButtonVariant } from "./types";

interface StyledButtonProps {
  $variant: ButtonVariant;
  $isActive?: boolean;
}

const getVariantStyles = ($variant: ButtonVariant, $isActive?: boolean) => {
  switch ($variant) {
    case "primary":
      return css`
        border: 1px solid ${designTokens.colors.line.button};
        gap: 4px;
        padding: 4px 10px;
        border-radius: 6px;
      `;
    case "download":
      return css`
        border: 1px solid ${designTokens.colors.line.button};
        gap: 4px;
        padding: 4px 16px;
        border-radius: 6px;
      `;
    case "like":
      return css`
        border: none;
        padding: 0;
        svg {
          width: 24px;
          height: 24px;
          fill: ${$isActive ? designTokens.colors.line.point : "transparent"};
          stroke: ${$isActive ? designTokens.colors.index.teal : "transparent"};
        }
        &:hover svg {
          fill: ${designTokens.colors.line.point};
        }
      `;
    case "dislike":
      return css`
        border: none;
        padding: 0;
        svg {
          width: 24px;
          height: 24px;
          fill: ${$isActive ? designTokens.colors.font.tertiary : "transparent"};
          stroke: ${$isActive ? designTokens.colors.index.gray : "transparent"};
        }
        &:hover svg {
          fill: ${designTokens.colors.font.tertiary};
        }
      `;
    case "outline":
    default:
      return;
  }
};

const StyledButton = styled.button<StyledButtonProps>`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  height: 32px;
  border-radius: 6px;
  ${getTypography("korean", "body4")};
  color: ${designTokens.colors.font.tertiary};
  cursor: pointer;
  transition: all 0.2s ease;
  background: transparent;

  ${(props) => getVariantStyles(props.$variant, props.$isActive)}
`;

const CommonActionButton: React.FC<ActionConfig> = ({
  label,
  onClick,
  variant = "primary",
  IconComponent,
  isActive,
}) => {
  return (
    <StyledButton onClick={onClick} $variant={variant} $isActive={isActive}>
      {IconComponent && <IconComponent />}
      {label && <span>{label}</span>}
    </StyledButton>
  );
};

export default CommonActionButton;
